import { merge } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { ThemeProvider } from 'styled-components';
import { customThemeProviderQueryCustomStyleQuery } from './__generated__/customThemeProviderQueryCustomStyleQuery.graphql';
import config from './config';
import { customThemeProviderQuery } from './customThemeProviderQuery';
import theme from './theme';

const CustomThemeProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const customStyleQuery = useLazyLoadQuery<customThemeProviderQueryCustomStyleQuery>(customThemeProviderQuery, {}, { fetchPolicy: 'network-only' });

    let [currentTheme, setCurrentTheme] = useState(theme);

    useEffect(() => {
        let customStyle = customStyleQuery.marketplaceCustomStyleForSeller?.customStyle;

        //faccio un merge del tema custom con il tema di default
        const nCustomTheme = merge({}, currentTheme, customStyle?.backofficeCustomTheme);

        //aggiungo le altre proprietà del tema custom in un nuovo oggetto
        nCustomTheme.additionalProperties = customStyle ? { ...customStyle } : {};
        delete nCustomTheme.additionalProperties.backofficeCustomTheme;

        nCustomTheme.additionalProperties = {
            ...(nCustomTheme.additionalProperties ?? {}),
            isToolbarHidden: nCustomTheme.additionalProperties?.isToolbarHidden || config.isToolbarHidden
        };

        setCurrentTheme(nCustomTheme);

        document.documentElement.style.background = nCustomTheme.app.backgroundColor;
    }, []);

    return <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>;
};

export default CustomThemeProvider;
